import * as React from 'react';
import { FiChevronDown } from 'react-icons/fi';

import styles from './filter-panel.scss';

interface FilterPanelProps {
  id: string;
  header: string;
  count: number;
  required?: boolean;
  open: boolean;

  openCloseFilter: (id: string, open: boolean) => void;
  children?: React.ReactNode;
}

interface FilterPanelState {
  isClosing: boolean;
}

export class FilterPanel extends React.PureComponent<FilterPanelProps, FilterPanelState> {

  private timer;

  public state: Readonly<FilterPanelState> = {
    isClosing: false
  };

  public componentWillUnmount() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = undefined;
    }
  }

  private onClick = () => {

    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = undefined;
    }

    if (this.props.open) {

      this.props.openCloseFilter(this.props.id, false);
      this.setState({
        isClosing: true
      });

      this.timer = setTimeout(() => {
        this.setState({
          isClosing: false
        });
      }, 300);

    } else {

      this.props.openCloseFilter(this.props.id, true);
      this.setState({
        isClosing: false
      });
    }
  };

  public render() {

    const { header: label, count, required, open, children } = this.props;

    const animateOutStyles = this.state.isClosing ? styles.animateOut : '';
    const isOpenStyles = open ? styles.isOpen : styles.isClosed;

    return <div className={`${styles.filterPanel} filter-panel`}>
      <button type="button" className={styles.titleStyle} onClick={this.onClick}>
        {!!required && <span className="asterisk-required">* </span>}
        {label}
        {count > 0 && <span> ({count})</span>}
        {<FiChevronDown className={open && !this.state.isClosing ? 'expand-icon-down' : 'expand-icon-up'} />}
      </button>

      <div className={`${animateOutStyles} ${isOpenStyles} ${styles.contentWrapper}`}>
        <div className={styles.content}>
          {children}
        </div>
      </div>
    </div>;
  }
}
